import FormBox from "./FormBox";
import Icon from "@lib/common/components/Icon/Icon";
import { Button, Group, Radio, Stack } from "@mantine/core";
import { useState } from "react";

export default function SingleSelectOptions({
  options,
  onSend
}: {
  options: { label: string }[];
  onSend: (v: string) => void;
}) {
  const [selected, setSelected] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSelect = () => {
    if (submitted || !selected) {
      return;
    }
    setSubmitted(true);
    onSend(selected);
  };

  if (submitted) {
    return null;
  }

  return (
    <FormBox>
      <Stack gap="lg">
        <Radio.Group value={selected} onChange={value => setSelected(value)} disabled={submitted} p="xs">
          <Stack gap="xs">
            {options.map(({ label }) => (
              <Radio key={label} value={label} label={label} fw={500} />
            ))}
          </Stack>
        </Radio.Group>
        <Group>
          <Button
            size="sm"
            disabled={submitted || selected === null}
            onClick={handleSelect}
            leftSection={<Icon name="check" size="0.7rem" variant="solid" />}
            variant="light"
          >
            Confirm
          </Button>
        </Group>
      </Stack>
    </FormBox>
  );
}
